/**
 * LinkHoverTooltip
 * Generic tooltip component for displaying link URLs on hover
 */

interface LinkHoverTooltipProps {
  url: string;
}

export const LinkHoverTooltip: React.FC<LinkHoverTooltipProps> = ({ url }) => {
  return (
    <div className='min-h-[42px] w-full rounded-md border border-gray-200 bg-white p-3 !no-underline'>
      <div className='break-all leading-normal text-black'>{url}</div>
    </div>
  );
};
